import {IWifiAnalyzerResults} from '../../services/AngularServices/WifiAnalyzerService';

export function sortWifiAnalyzerResultsByDateDesc(scans: IWifiAnalyzerResults[]): IWifiAnalyzerResults[] {
    return [...scans].sort(
        (a, b) => new Date(b.updatedAt || b.createdOn).getTime() - new Date(a.updatedAt || a.createdOn).getTime()
    );
}

export function getWifiAnalyzerScanRecordId(scan: IWifiAnalyzerResults): string {
    const id = scan?._id || scan?.id;
    return id != null && String(id) !== '' ? String(id) : '';
}

/**
 * Keeps first occurrence per scan id. With newest-first input (see sortWifiAnalyzerResultsByDateDesc),
 * the retained row is the latest for that id.
 */
export function dedupeWifiAnalyzerResultsByScanId(scans: IWifiAnalyzerResults[]): IWifiAnalyzerResults[] {
    const seen = new Set<string>();
    const result: IWifiAnalyzerResults[] = [];
    for (const scan of scans) {
        const rid = getWifiAnalyzerScanRecordId(scan);
        if (!rid) {
            result.push(scan);
            continue;
        }
        if (seen.has(rid)) {
            continue;
        }
        seen.add(rid);
        result.push(scan);
    }
    return result;
}

/**
 * Canonical list for sidebar history: newest first, one row per scan id.
 * Use after API/history payloads (any order) and after incremental pushes.
 */
export function normalizeWifiAnalyzerHistoryList(scans: IWifiAnalyzerResults[]): IWifiAnalyzerResults[] {
    return dedupeWifiAnalyzerResultsByScanId(sortWifiAnalyzerResultsByDateDesc(scans));
}
